import React from 'react';
import './MarketplaceTabs.css';

const MARKETPLACES = ['amazon', 'walmart', 'shopify', 'etsy', 'summary'];

const MarketplaceTabs = ({ activeMarketplace, onMarketplaceChange }) => {
  return (
    <div className="marketplace-tabs">
      {MARKETPLACES.map((market) => (
        <button
          key={market}
          className={`marketplace-tab ${activeMarketplace === market ? 'active' : ''}`}
          onClick={() => onMarketplaceChange(market)}
        >
          {market.charAt(0).toUpperCase() + market.slice(1)}
        </button>
      ))}
    </div>
  );
};

export default MarketplaceTabs;